import { render, staticRenderFns } from "./addCalcRule.vue?vue&type=template&id=821c25d2&scoped=true"
import script from "./addCalcRule.vue?vue&type=script&lang=js"
export * from "./addCalcRule.vue?vue&type=script&lang=js"
import style0 from "./addCalcRule.vue?vue&type=style&index=0&id=821c25d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821c25d2",
  null
  
)

export default component.exports